export default class TestReports {

	constructor(name) {

		window[name] = this.data()
	}

	data() {
		return {
			loading: true,
			items: [],
			query: '',
			init(ItemId,groupId) {
				var vm = this
				var xhttp = new XMLHttpRequest();
				vm.groupId = groupId
				vm.items = []
				vm.loading = true
				xhttp.onreadystatechange = function() {

					if (this.readyState == 4 && this.status == 200) {
						vm.loading = false
						vm.items = JSON.parse(this.responseText);
					}

					if( vm.items == undefined){
						vm.items = [];
					}
				}

				xhttp.open('get', '/api/test-report/' + ItemId , true);
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				// setTimeout(function() {
					xhttp.send();
				// }, 500)
			},

			EditItem(item) {
				var currentUrl = window.location
				currentUrl += currentUrl.toString().endsWith("/") ? "" : "/"  
				Turbolinks.visit( currentUrl + "test-report/"  + item.id )
			},


			filterItems(vm = this) {

				var AllItems = vm.items;
				var SearchableKeys = ['id']
				var SearchString = vm.query.toLowerCase();

				return AllItems.filter(product => {
					let flag = false;
					for (let SearchKey of SearchableKeys) {
						if( product[SearchKey] ){
							flag = product[SearchKey].toString().toLowerCase().indexOf(SearchString) > -1
						}
						if (flag) break;
					}
					return flag;
				});
			}
		}
	}
}